// extracted by mini-css-extract-plugin
module.exports = {"points":"LoyaltyPreviewDescription_points__6tRdN","redeemQuestion":"LoyaltyPreviewDescription_redeemQuestion__3fikl","redeemButton":"LoyaltyPreviewDescription_redeemButton__esuKW"};